import { useAuthContext } from "@/features/authentication/useAuthContext";
import type { Recipe } from "@/features/Recipes-renamed/types";
import { mapDatabaseRecipeToRecipe } from "@/lib/mapDatabaseRecipeToRecipe";
import { supabase } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";

export function useGetRecipe(id?: number) {
    const { user } = useAuthContext();
    const { data, isPending, isError } = useQuery<Recipe>({
        queryKey: ["recipe", id],
        queryFn: async () => {
            const { data, error } = await supabase
                .from("recipes")
                .select(
                    `
                    *,
                    recipe_types (*),
                    recipe_categories (*),
                    ingredient_groups (*, ingredients (*))
                `
                )
                .eq("id", id!)
                .eq("user_id", user!.id)
                .single();

            if (error || !data) {
                console.error("Error fetching recipes:", error);
                throw error;
            }

            const recipe: Recipe = mapDatabaseRecipeToRecipe(data!);
            return recipe;
        },
        enabled: !!id
    });

    return { data, isPending, isError };
}
